module.exports = __webpack_public_path__ + "assets/Crowding.91c47bb7610896a6b64f6f0559101d9a.png";